module.exports = __webpack_public_path__ + "static/banner.ca6d8c0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/banner.png
// module id = 434
// module chunks = 35783957827783